<template>
  <div class="-mx-1">
    <div class="px-1 w-full">
      <h2 class="font-bold text-2xl">Sastavnica</h2>
    </div>
    <div class="px-1 flex mt-2" v-if="selectedProducts.length > 0" v-for="(product, index) in selectedProducts" :key="index">
      <div class="form-group w-1/3 pr-16">
        <label :for="`product-${index}`" class="form-label">Odaberi proizvod</label>
        <v-select
            :id="`product-${index}`"
            :filterable="false"
            :options="products"
            :reduce="product => product.id"
            v-model="product.value"
            label="title"
        >
        </v-select>
        <input type="hidden" :name="`product[${index}][id]`" :value="product.value">
      </div>

      <div class="form-group w-1/8">
        <label :for="`product-quantity-${index}`" class="form-label">Količina</label>
        <input type="number" class="form-control" :name="`product[${index}][quantity]`" v-model="product.quantity">
      </div>

      <div class="form-group w-1/4">
        <button :id="`remove-product-${index}`" type="button" class="btn btn-delete border-0 mt-8 px-2 ml-4 hover:text-primary flex" @click="removeProduct(index)">Ukloni</button>
      </div>
    </div>
    <div class="flex w-1/5 items-center mb-1 mt-4">
      <button
          class="btn btn-lg btn-success"
          @click.prevent="addNewProduct()"
      >
        <span>Dodaj stavku</span>
      </button>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
Vue.component('v-select', vSelect);
export default {
name: "ProductComp",
  props:{
    products:{
      type: Array,
      required: true,
    }
  },
  data(){
  return{
    listProducts: [],
    selectedProducts: [],

  }
  },
  created()
  {
    this.initProducts()
  },
  methods: {
    removeProduct(index) {
      this.selectedProducts.splice(index, 1)
    },
    addNewProduct() {
      this.selectedProducts.push({
        value: null,
        quantity: 1,
      });
    },
    initProducts() {
      if (this.selectedProducts.length === 0) {
        this.addNewProduct()
      }
    },

  }

}
</script>

